import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';

import type {
  GetActiveCatalogHeaderResponse,
  GetActiveCatalogResponse,
} from './type';

/**
 * Active デバイスカタログ情報取得（読み取り専用）
 */
export async function getActiveCatalog(
  id: string,
): Promise<GetActiveCatalogResponse> {
  const res = await apiClient.GET('/v2/device-catalogs/active/{id}', {
    params: { path: { id } },
  });
  return getDataOrThrowApiError(res);
}

/**
 * Active デバイスカタログ ヘッダー情報取得
 */
export async function getActiveCatalogHeader(
  id: string,
): Promise<GetActiveCatalogHeaderResponse> {
  const res = await apiClient.GET(
    '/v2/device-catalogs/active/{id}/profile-header',
    {
      params: { path: { id } },
    },
  );
  return getDataOrThrowApiError(res);
}

/**
 * Active デバイスカタログをアーカイブ
 */
export async function archiveActiveCatalog(
  id: string,
  archivedReason?: string | null,
): Promise<void> {
  const res = await apiClient.POST('/v2/device-catalogs/active/{id}/archive', {
    params: { path: { id } },
    body: { archivedReason },
  });
  getDataOrThrowApiError(res);
}
